/**
 * @desc 财务公司间交易表分页查询
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.FinanceAndTaxationResponseDto>>;
export function request(
  params: API.tms.stockOccupyDetail.financeAndCompanyPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupyDetail/financeAndCompanyPage`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
